// @flow
const MESSAGE = 'Internal Server Error'

// HACK (jake): workaround for https://stackoverflow.com/a/33877501/393075
export default class InternalServerError extends Error {
  static isInternalServerError = (error: any) => {
    return error instanceof Error && error.message === MESSAGE
  }

  constructor() {
    super(MESSAGE)
  }
}
